// forum.js
export default {
    forum_name: '论坛名称',
    search: '搜索',
    reset: '重置',
    create_forum: '创办论坛',
    serial_number: '序号',
    forum_name_again: '论坛名称',
    status: '状态',
    start_time_to_end_time: '开展时间',
    founder: '创办人',
    operation: '操作',
    manage: '管理',
    edit: '编辑',
    delete: '删除',
    prompt: '提示',
    confirm_delete_forum: '确定删除该论坛吗？',
    confirm: '确定',
    cancel: '取消',
    delete_success: '删除成功',
    operation_success: '操作成功',
    edit_forum: '编辑论坛',
    basic_info: '基本信息',
    forum_english_name: '论坛英文名称',
    start_time: '开展时间',
    belonging_area: '所属地区',
    detailed_address: '详细地址',
    cover_image: '封面图',
    upload_image: '上传图片',
    introduction: '简介',
    please_input_forum_name: '请输入论坛名称',
    please_input_forum_english_name: '请输入论坛英文名称',
    please_select_start_time: '请选择开展时间',
    please_input_detailed_address: '请输入详细地址',
    please_upload_cover_image: '请上传封面图',
    please_input_introduction: '请输入简介',
    you_can_only_upload_image_files: '您只能上传图像文件',
    end: '已结束',
    doing: '进行中',
    please_input_forum_id: '请输入论坛ID',
    status_on: '开启',
    status_off: '关闭',
    forumLink: '报名链接',
    confirm_delete_forum_goods: '确定解绑该门票吗？',
    bind_goods: '绑定门票',
    del_bind: '解除绑定'
};
